import {
  getIsListingPublishBlocked,
  RentalPortalListingAlreadyPublishedChip,
  RentalPortalListingStatusBadge,
} from '../../../RentalPortalListing'
import { TableCellBase } from '../../../Table'

import * as styles from './RentalPortalListingsStatusCell.module.css'

function RentalPortalListingsStatusCell({ item, ...restProps }) {
  return (
    <TableCellBase
      {...restProps}
      className={styles.RentalPortalListingsStatusCell}
    >
      <RentalPortalListingStatusBadge listing={item} />
      {getIsListingPublishBlocked(item) ? (
        <RentalPortalListingAlreadyPublishedChip
          flatPublishedListing={item.flat_published_listing}
        />
      ) : null}
    </TableCellBase>
  )
}

export default RentalPortalListingsStatusCell
